import { create } from 'zustand'

interface BirthdayState {
  todayIds: Set<string>
  loaded: boolean
  isBirthday: (userId?: string | null) => boolean
  loadToday: () => Promise<void>
}

export const useBirthdayStore = create<BirthdayState>((set, get) => ({
  todayIds: new Set(),
  loaded: false,
  isBirthday: (userId) => !!userId && get().todayIds.has(userId),
  loadToday: async () => {
    try {
      // Lazy import avoids pulling axios + sibling modules into jsdom tests.
      const { default: api } = await import('../../services/api')
      const res = await api.get<{ userIds: string[] }>('/birthdays/today')
      set({ todayIds: new Set(res.data.userIds), loaded: true })
    } catch {
      set({ loaded: true })
    }
  },
}))
